import Dexie from "dexie"

const db = new Dexie("mcs")
db.version(1).stores({
	tokens: "id, value",
})

export const tokensdb = db.table("tokens")
